"use client";
import * as React from "react";
const SvgChevronRightRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 8 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1 .71a1 1 0 0 0 0 1.41L4.88 6 1 9.88a1 1 0 1 0 1.41 1.41L7 6.7a1 1 0 0 0 0-1.41L2.41.7A1 1 0 0 0 1 .71" }));
export {
  SvgChevronRightRound as default
};
